/* MailBakes message helper - a curated writer, not a live AI call.
   A theme cannot hold an API key safely (everything in theme JS is public),
   so this composes from lines written per occasion and tone. Instant, free,
   and it cannot produce anything off-brand. */
(function () {
  'use strict';
  var host = document.querySelector('[data-mb-helper]');
  var ta = document.getElementById('mb-msg');
  if (!host || !ta) return;

  var B = {
    birthday: {
      warm: ['Happy birthday {who}. Hope today is every bit as lovely as you are.',
        'Happy birthday {who}! Wish I could be there to share this. Save me a bite.',
        '{who} - happy birthday. Thinking of you today and sending something sweet to prove it.'],
      funny: ['Happy birthday {who}. Cake in the post, because posting a whole party seemed excessive.',
        '{who}, another year older and somehow still my favourite. Eat the cake.',
        'Happy birthday {who}! No candles - the postman was very firm about that.'],
      short: ['Happy birthday {who}. Enjoy every crumb. x', '{who} - happy birthday! Sending cake and love. x',
        'Have the loveliest birthday {who}. x'],
      poem: ['A slice in the post, a wish from afar,\nhappy birthday {who} - stay just as you are.',
        'No candles, no party, no big fuss to make,\njust love from me {who}, and quite a good cake.']
    },
    anniversary: {
      warm: ['Happy anniversary {who}. Here is to all the years behind you and every one still coming.',
        '{who} - happy anniversary. Still the loveliest pair I know.'],
      funny: ['Happy anniversary {who}. Still not sick of each other? Impressive. Have cake.',
        '{who}, congratulations on another year of putting up with each other.'],
      short: ['Happy anniversary {who}. x', '{who} - happy anniversary! Sending love and cake. x'],
      poem: ['Through all of the years, whatever they make,\nhappy anniversary {who} - have some cake.']
    },
    thanks: {
      warm: ['Thank you {who}. You have no idea how much it meant - here is a little something sweet.',
        '{who}, thank you. Properly, genuinely thank you.'],
      funny: ['Thank you {who}. Cake felt more useful than a card and far easier than a hug by post.',
        '{who} - thank you. Payment accepted in sponge only.'],
      short: ['Thank you {who}. x', '{who} - thank you, truly. x'],
      poem: ['A small thank you {who}, sent through the door,\nfor everything done, and so much more.']
    },
    thinking: {
      warm: ['Thinking of you {who}. No need to reply - just wanted you to know.',
        '{who}, thinking of you today. Have a cup of tea and this.'],
      funny: ['Thinking of you {who}. Could not fix anything, so I sent cake instead.',
        '{who} - cake will not solve it, but it rarely makes things worse.'],
      short: ['Thinking of you {who}. x', '{who} - here if you need me. x'],
      poem: ['No fixing, no fussing, no big words to say,\njust thinking of you {who}, today.']
    },
    congrats: {
      warm: ['Congratulations {who}! So pleased for you - properly, genuinely pleased.',
        '{who}, congratulations. You have earned every bit of this.'],
      funny: ['Congratulations {who}. I would have brought champagne but it does not fit through the letterbox.',
        '{who} - well done. Celebrate with cake, it travels better.'],
      short: ['Congratulations {who}! x', 'Well done {who} - so proud. x'],
      poem: ['You did the thing, you saw it through,\ncongratulations {who} - this cake is for you.']
    },
    justbecause: {
      warm: ['No reason {who} - just thought of you and wanted you to know.',
        '{who}, no occasion. Just cake, and me thinking about you.'],
      funny: ['No reason {who}. I was ordering cake anyway and your name came up.',
        '{who} - this is not a hint about anything. It is just cake.'],
      short: ['Just because {who}. x', 'Thinking of you {who} - no reason. x'],
      poem: ['No birthday, no reason, no date to recall,\njust cake for you {who}, and that is all.']
    }
  };

  var last = '';
  function pick(occ, tone, who) {
    var set = (B[occ] || B.birthday)[tone] || (B[occ] || B.birthday).warm;
    var out = [], pool = set.slice();
    while (out.length < 3 && pool.length) {
      var i = Math.floor(Math.random() * pool.length);
      out.push(pool.splice(i, 1)[0]);
    }
    return out.map(function (t) { return t.replace(/\{who\}/g, who || 'you'); });
  }

  function render() {
    var who = host.querySelector('[name=who]').value.trim();
    var occ = host.querySelector('[name=occ]').value;
    var tone = host.querySelector('[name=tone]').value;
    var out = host.querySelector('[data-mb-out]');
    var list = pick(occ, tone, who);
    if (list.join('|') === last && list.length > 1) list.reverse();
    last = list.join('|');
    out.innerHTML = list.map(function (t, i) {
      return '<div class="mb-sug"><div class="mb-sug__t">' +
        t.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\n/g, '<br>') +
        '</div><button type="button" class="mb-btn mb-btn--ghost mb-btn--sm" data-use="' + i + '">Use this</button></div>';
    }).join('') +
      '<button type="button" class="mb-btn mb-btn--ghost mb-btn--sm" data-more style="margin-top:4px">Three more</button>';
    out.dataset.list = JSON.stringify(list);
  }

  host.addEventListener('click', function (e) {
    if (e.target.closest('[data-mb-go]') || e.target.closest('[data-more]')) { render(); return; }
    var u = e.target.closest('[data-use]');
    if (u) {
      var list = JSON.parse(host.querySelector('[data-mb-out]').dataset.list || '[]');
      ta.value = list[+u.getAttribute('data-use')] || '';
      ta.dispatchEvent(new Event('input', { bubbles: true }));
      ta.focus();
    }
  });
})();
